import { render, staticRenderFns } from "./AdjustableLookUpTable.vue?vue&type=template&id=1bad28e4&scoped=true&"
import script from "./AdjustableLookUpTable.vue?vue&type=script&lang=js&"
export * from "./AdjustableLookUpTable.vue?vue&type=script&lang=js&"
import style0 from "./AdjustableLookUpTable.vue?vue&type=style&index=0&id=1bad28e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad28e4",
  null
  
)

export default component.exports